/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Threshold_HintInputs */

const he_notifications_threshold_hint = /** @type {(inputs: Notifications_Threshold_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תקבלו התראה כאשר המחיר יירד מתחת לסכום שבחרתם`)
};

const en_notifications_threshold_hint = /** @type {(inputs: Notifications_Threshold_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll be notified when the price drops below your target`)
};

/**
* | output |
* | --- |
* | "You'll be notified when the price drops below your target" |
*
* @param {Notifications_Threshold_HintInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_threshold_hint = /** @type {((inputs?: Notifications_Threshold_HintInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Threshold_HintInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_threshold_hint(inputs)
	return en_notifications_threshold_hint(inputs)
});